async function initMap() {
    // Request needed libraries for advanced markers
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    // Create the map.
    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 7,
        center: { lat: 52, lng: 5.689423 },
        mapId: "DEMO_MAP_ID", // Map ID is required for advanced markers
    });

    // Load the stores GeoJSON onto the map.
    console.log("Checking for locations data:", window.locationsData);
    if (window.locationsData) {
        console.log("Using injected locations data");
        map.data.addGeoJson(window.locationsData, { idPropertyName: "storeid" });
    } else {
        console.log("Falling back to URL loading");
        // Fallback to loading from URL if data isn't available
        //map.data.loadGeoJson("https://cdn.shopify.com/s/files/1/0938/5659/6299/files/locations.json?v=1756905833", { idPropertyName: "storeid" });
    }

    // Define the custom marker icons, using the store's "category".
    map.data.setStyle((feature) => {
        return {
            icon: {
                url: `https://cdn.shopify.com/s/files/1/0938/5659/6299/files/Circle_DJI.png?v=1756892236`,
                scaledSize: new google.maps.Size(32, 32),
            },
        };
    });

    const infoWindow = new google.maps.InfoWindow();

    // Show the information for a store when its marker is clicked.
    map.data.addListener("click", (event) => {
        const name = event.feature.getProperty("name");
        const description = event.feature.getProperty("description");
        const phone = event.feature.getProperty("phone");
        const position = event.feature.getGeometry().get();
        const logo = event.feature.getProperty("logo");
        const email = event.feature.getProperty("email");
        const website = event.feature.getProperty("website");
        const services = event.feature.getProperty("services");
        const contact_internal = event.feature.getProperty("contact_internal")
        const content = `
            <div class="store-info-window">
                <div class="store-info-header">
                    <img class="store-info-logo" src="${logo}" alt="${name}">
                    <div class="store-info-details">
                        <h2 class="store-info-name">${name}</h2>
                        <div class="store-info-contact">
                            <div class="store-info-contact-item"><strong>Phone:</strong> <a href="tel:${phone}">${phone}</a></div>
                            <div class="store-info-contact-item"><strong>Email:</strong> <a href="mailto:${email}">${email}</a></div>
                            <div class="store-info-contact-item"><strong>Website:</strong> <a href="${website}?utm_source=dji_ag_benelux&utm_medium=service_map&utm_campaign=card_link" target="_blank">${website}</a></div>
                            <div class="store-info-content-item"><a href="${contact_internal}">Meer info</a></div>
                        </div>
                    </div>
                </div>
                ${services && services.length > 0 ? `
                <div class="store-info-services">
                    <span class="store-info-services-title">Services:</span>
                    <ul>
                        ${services.map(service => `<li>${service}</li>`).join("")}
                    </ul>
                </div>
                ` : ''}
            </div>
        `;

        infoWindow.setContent(content);
        infoWindow.setPosition(position);
        infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
        infoWindow.open(map);
    });

    // Build and add the search bar
    const card = document.createElement("div");
    const titleBar = document.createElement("div");
    const title = document.createElement("div");

    card.setAttribute("id", "pac-card");
    title.setAttribute("id", "title");
    title.textContent = "Find the nearest service provider";
    titleBar.appendChild(title);
    card.appendChild(titleBar);
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    // Make the search bar into a Places Autocomplete search bar using the new API
    const autocomplete = new google.maps.places.PlaceAutocompleteElement({
        types: ["address"],
        componentRestrictions: { country: ["nl", "be", "lu"] }
    });

    // Add the autocomplete element to the card
    card.appendChild(autocomplete);

    // Set the origin point when the user selects an address
    const originMarker = new AdvancedMarkerElement({
        map: map,
        position: map.getCenter()
    });
    originMarker.visible = false;
    let originLocation = map.getCenter();

    // Get user's current location and show it with the existing marker
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const userLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                // Use the existing originMarker to show user location
                originMarker.position = userLocation;
                originMarker.visible = true;
                originLocation = userLocation;

                console.log("User location marked:", userLocation);

                // Center the map on user location
                map.setCenter(userLocation);
                map.setZoom(10);
            },
            (error) => {
                console.log("Could not get user location:", error.message);
            }
        );
    }

    // Listen for place selection using the new gmp-select event
    autocomplete.addEventListener("gmp-select", async (event) => {
        originMarker.visible = false;
        originLocation = map.getCenter();

        try {
            // Get the place from the event and fetch the required fields
            const place = event.placePrediction.toPlace();
            await place.fetchFields({
                fields: ["formattedAddress", "location", "viewport"]
            });

            if (!place || !place.location) {
                window.alert("No address available for the selected location");
                return;
            }

            // Recenter the map to the selected address
            originLocation = place.location;

            // Use viewport if available, otherwise center on location
            if (place.viewport) {
                map.fitBounds(place.viewport);
            } else {
                map.setCenter(originLocation);
                map.setZoom(9);
            }

            console.log("Selected place:", place);

                        originMarker.position = originLocation;
    originMarker.visible = true;

            // Use the selected address as the origin to calculate distances
            // to each of the store locations
            const rankedStores = await calculateDistances(map.data, originLocation);
            showStoresList(map.data, rankedStores);
        } catch (error) {
            console.error("Error processing place selection:", error);
            window.alert("Error processing the selected location");
        }
    });
}

async function calculateDistances(data, origin) {
    const stores = [];
    const destinations = [];

    // Build parallel arrays for the store IDs and destinations
    data.forEach((store) => {
        const storeNum = store.getProperty("storeid");
        const storeLoc = store.getGeometry().get();

        stores.push(storeNum);
        destinations.push(storeLoc);
    });

    // Retrieve the distances of each store from the origin
    // The returned list will be in the same order as the destinations list
    const service = new google.maps.DistanceMatrixService();
    const getDistanceMatrix = (service, parameters) =>
        new Promise((resolve, reject) => {
            service.getDistanceMatrix(parameters, (response, status) => {
                if (status != google.maps.DistanceMatrixStatus.OK) {
                    reject(response);
                } else {
                    const distances = [];
                    const results = response.rows[0].elements;
                    for (let j = 0; j < results.length; j++) {
                        const element = results[j];
                        const distanceText = element.distance.text;
                        const distanceVal = element.distance.value;
                        const distanceObject = {
                            storeid: stores[j],
                            distanceText: distanceText,
                            distanceVal: distanceVal,
                        };
                        distances.push(distanceObject);
                    }

                    resolve(distances);
                }
            });
        });

    const distancesList = await getDistanceMatrix(service, {
        origins: [origin],
        destinations: destinations,
        travelMode: "DRIVING",
        unitSystem: google.maps.UnitSystem.METRIC,
    });

    distancesList.sort((first, second) => {
        return first.distanceVal - second.distanceVal;
    });

    return distancesList;
}

function showStoresList(data, stores) {
    if (stores.length == 0) {
        console.log("empty stores");
        return;
    }

    let panel = document.createElement("div");
    // If the panel already exists, use it. Else, create it and add to the page.
    if (document.getElementById("panel")) {
        panel = document.getElementById("panel");
        // If panel is already open, close it
        if (panel.classList.contains("open")) {
            panel.classList.remove("open");
        }
    } else {
        panel.setAttribute("id", "panel");
        const body = document.body;
        body.insertBefore(panel, body.childNodes[0]);
    }

    // Clear the previous details
    while (panel.lastChild) {
        panel.removeChild(panel.lastChild);
    }

    stores.forEach((store) => {
        // Add store details with text formatting
        const name = document.createElement("p");
        name.classList.add("place");
        const currentStore = data.getFeatureById(store.storeid);
        name.textContent = currentStore.getProperty("name");
        panel.appendChild(name);
        const distanceText = document.createElement("p");
        distanceText.classList.add("distanceText");
        distanceText.textContent = store.distanceText;
        panel.appendChild(distanceText);
    });

    // Open the panel
    panel.classList.add("open");

    return;
}

const mapStyle = [
    {
        featureType: "administrative",
        elementType: "all",
        stylers: [
            {
                visibility: "on",
            },
            {
                lightness: 33,
            },
        ],
    },
    {
        featureType: "landscape",
        elementType: "all",
        stylers: [
            {
                color: "#f2e5d4",
            },
        ],
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
            {
                color: "#c5dac6",
            },
        ],
    },
    {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [
            {
                visibility: "on",
            },
            {
                lightness: 20,
            },
        ],
    },
    {
        featureType: "road",
        elementType: "all",
        stylers: [
            {
                lightness: 20,
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
            {
                color: "#c5c6c6",
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            {
                color: "#e4d7c6",
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                color: "#fbfaf7",
            },
        ],
    },
    {
        featureType: "water",
        elementType: "all",
        stylers: [
            {
                visibility: "on",
            },
            {
                color: "#acbcc9",
            },
        ],
    },
];
